import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { string, object, oneOfType, bool, number } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';
import { withRouter } from 'react-router-dom';

class MethodBtn extends Component {
  static propTypes = {
    btnLabelId: string.isRequired,
    className: string,
    type: string,
    size: string,
    color: string,
    api: object.isRequired,
    method: string.isRequired,
    params: oneOfType([object, string, bool, number]),
  }
  static defaultProps = {
    type: 'button',
    size: 'sm',
    color: 'primary',
    params: {},
    className: '',
  }
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      disabled: props.disabled ? props.disabled : false,
      isModalOpen: false,
    };
  }

  handleSubmit = () => {
    const {
      api,
      method,
      params,
      redirectPath,
      customAction,
      history,
      timeOut,
      withModal,
    } = this.props;
    this.setState(() => ({ loading: true, disabled: true }));
    api[method](params)
      .then(() => {
        withModal && this.toggleModal();
        customAction && customAction();
        if(redirectPath) {
          if(timeOut) {
            setTimeout(() => {
              history.push(redirectPath);
            }, timeOut);
          } else {
            history.push(redirectPath);
          }
        }
      });
  }

  handleClick = () => {
    const { withModal } = this.props;
    withModal ? this.toggleModal() : this.handleSubmit();
  };

  renderModal = ({
    body,
    yesBtnId,
    noBtnId
  }) => {
    const { isModalOpen, loading } = this.state;
    return (
      <Modal
        isOpen={isModalOpen}
        toggle={this.toggleModal}
        centered
      >
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
          <Button className="btn-sm" color="light" onClick={this.toggleModal}>
            <FMessage id={noBtnId ? noBtnId : 'main.no'}/>
          </Button>
          <Button className="btn-sm" type="submit" disabled={loading} color="primary" onClick={this.handleSubmit}>
            <FMessage id={yesBtnId ? yesBtnId : 'main.yes'}/>
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  toggleModal = () => {
    this.setState(({isModalOpen}) => ({isModalOpen: !isModalOpen}));
  }

  render() {
    const { disabled } = this.state;
    const {
      btnLabelId,
      withModal,
      modalProps,
      redirectPath,
      isIcon,
      iconProps,
      history,
      location,
      staticContext,
      match,
      params,
      method,
      customAction,
      timeOut,
      api,
      ...rest
    } = this.props;
    return (
      <Fragment>
        {!isIcon ?
          <Button
            {...rest}
            disabled={disabled}
            onClick={this.handleClick}
          >
            <FMessage id={btnLabelId} />
          </Button>
          :
          <Icon
            {...iconProps}
            onClick={this.handleClick}
          />
        }
        {withModal && this.renderModal(modalProps)}
      </Fragment>
    );
  }
}

export default withRouter(MethodBtn);
